export const getSurveyApiBaseUrl = (): URL => {
  const protocol =
    (import.meta.env.VITE_MX8_SURVEY_API_PROTOCOL as string) ?? "https";
  const domain = import.meta.env.VITE_MX8_SURVEY_API_DOMAIN as string;

  if (!domain) {
    throw new Error("Missing survey API domain configuration");
  }

  // Ensure the domain is a simple hostname without path or credential components
  if (["/", "\\", "@"].some((part) => domain.includes(part))) {
    throw new Error("Invalid survey API domain configuration");
  }

  const normalizedProtocol = protocol.replace(/:$/, "");
  if (!["http", "https"].includes(normalizedProtocol)) {
    throw new Error("Invalid survey API protocol configuration");
  }
  const apiUrl = new URL(`${normalizedProtocol}://${domain}`);
  if (import.meta.env.PROD && apiUrl.protocol !== "https:") {
    throw new Error("Survey API must use https in production");
  }

  return apiUrl;
};
